"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.566 3.31a.7.7 0 0 1 .7.7v7.322l3.818-3.075a.7.7 0 1 1 .879 1.09L6.966 11.76l3.1 3.786a.7.7 0 1 1-1.084.886L5.876 12.64l-.61.491v2.86a.7.7 0 1 1-1.4 0V4.01a.7.7 0 0 1 .7-.7m7.023 4.792a.7.7 0 0 1 .7.7v.66q.03-.018.061-.033c.752-.392 1.847-.756 3.09-.516a.7.7 0 0 1-.266 1.375c-.822-.16-1.586.075-2.177.383a5 5 0 0 0-.691.44l-.017.012v4.867a.7.7 0 1 1-1.4 0V8.802a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.133 15.783a.826.826 0 1 1-1.652 0 .826.826 0 0 1 1.652 0"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencyDanishKroneIcon20.js.map